/* unplugin-vue-components disabled */import { render } from "./tenant-feed.vue?vue&type=template&id=8ebbe982&scoped=true"
import script from "./tenant-feed.vue?vue&type=script&lang=js"
export * from "./tenant-feed.vue?vue&type=script&lang=js"

import "./tenant-feed.vue?vue&type=style&index=0&id=8ebbe982&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ebbe982"],['__file',"src/pages/tenants/settings/tenant-feed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ebbe982"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ebbe982', __exports__)) {
    api.reload('8ebbe982', __exports__)
  }
  
  module.hot.accept("./tenant-feed.vue?vue&type=template&id=8ebbe982&scoped=true", () => {
    api.rerender('8ebbe982', render)
  })

}


export default __exports__